module.exports = __webpack_public_path__ + "img/drag.ae5816f6.svg";